import React, { useState } from "react";
import Grid from "@mui/material/Grid";

import styled from "@emotion/styled";

import MiniSearchBar from "components/layouts/MiniSearchBar";
import EmptyTable from "components/utils/table-layouts/EmptyTable";
import { DiscountedSalariesRows } from "helpers/datasets/table-rows";
import { IconExport, IconFilter } from "../../assets/icons";
import PayoutHeader from "components/layouts/PayoutHeader";
import DiscountedSalariesTable from "components/layouts/DiscountedSalariesTable";

const inflowRows = DiscountedSalariesRows;

function DiscountedSalaries() {
  const [searchQuery, setSearchQuery] = useState("");

  const handleChange = (e) => {
    setSearchQuery(e.target.value);
  };

  return (
    <ReferralsStyles>
      <PayoutHeader
        title="Discounted Salaries"
        subTitle="This displays the overall transactions"
      />
      <hr />
      <div className="search-filter-export">
        <div className="inputSearch">
          <MiniSearchBar
            name={searchQuery}
            color="#fff"
            onChange={handleChange}
            value={searchQuery}
            placeHolder="Search client, name or property..."
            className="longSearch"
          /> 
        </div>
        <div className="filter-export">
          <div className="filter">
            <IconFilter /> <h3>Filters</h3>
          </div>
          <div className="export">
            <IconExport />               <h3 style={{ color: "black" }}>Export</h3>

          </div>
        </div>
      </div>
      <hr />

      <div className="table">
        <Grid container>
          {inflowRows.length === 0 ? (
            <DiscountedSalariesTable />
          ) : (
            <EmptyTable />
          )}
        </Grid>
      </div>
    </ReferralsStyles>
  );
}

export default DiscountedSalaries;

const ReferralsStyles = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 120vh;
  height: 100%;
  width: 100%;
  background-color: var(--gray-2);

  @media (max-width: 800px) {
    margin-top: 20px;
  }

  .table {
    margin: 20px 40px;

    @media (max-width: 640px) {
      margin: 20px;
      display: flex;
      justify-content: center;
      width: 100%;
      height: 125vh;
    }
  }

  .search-filter-export {
    padding: 15px 0px;
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-between;

    @media (max-width: 640px) {
      flex-direction: column;
      align-items: center;
      padding: 15px 20px;
    }
  }

  hr {
    width: 100%;
    background: #0404061a;

    @media (max-width: 640px) {
      width: 113%;
    }
  }

  .inputSearch {
    margin-left: 38px;
    @media (max-width: 640px) {
      width: 100%;
      display: flex;
      justify-content: center;
      margin-left: -38px;
    }
  }

  .filter-export {
    display: flex;

    @media (max-width: 640px) {
      margin-top: 10px;
    }

    .export,
    .filter {
      margin-right: 38px;
      width: 100px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: none;
      outline: none;
      background-color: #ffffff;
      cursor: pointer;

      @media (max-width: 640px) {
        width: 45vw;
      }

      svg {
        width: 20px;
        height: 20px;
      }

      h3 {
        color: var(--gray-3);
        font-size: 15px;
        font-weight: 400;
        font-style: normal;
      }
    }
  }
`;
